import { useMemo } from "react";

export interface SlackSourceSettingsText {
  modeLabelText: string;
  modeReactionsText: string;
  modeListsText: string;
  reactionLabelText: string;
  reactionPlaceholderText: string;
  reactionHintText: string;
  reactionRequiredText: string;
  includeFilesText: string;
  channelLabelText: string;
  channelPlaceholderText: string;
  channelHintText: string;
  loadingChannelsText: string;
  loadErrorText: string;
  listLabelText: string;
  listPlaceholderText: string;
  listHintText: string;
  addListText: string;
  removeListText: string;
  resolvingListText: string;
  listErrorText: string;
  noListsText: string;
  onlyAssignedToMeText: string;
}

export const useSlackSourceSettingsText = (
  t: (key: string) => string,
): SlackSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.slack.${key}`);

    return {
      modeLabelText: tKey("modeLabel"),
      modeReactionsText: tKey("modeReactions"),
      modeListsText: tKey("modeLists"),
      reactionLabelText: tKey("reactionLabel"),
      reactionPlaceholderText: tKey("reactionPlaceholder"),
      reactionHintText: tKey("reactionHint"),
      reactionRequiredText: tKey("reactionRequired"),
      includeFilesText: tKey("includeFiles"),
      channelLabelText: tKey("channelLabel"),
      channelPlaceholderText: tKey("channelPlaceholder"),
      channelHintText: tKey("channelHint"),
      loadingChannelsText: tKey("loadingChannels"),
      loadErrorText: tKey("loadError"),
      listLabelText: tKey("listLabel"),
      listPlaceholderText: tKey("listPlaceholder"),
      listHintText: tKey("listHint"),
      addListText: tKey("addList"),
      removeListText: tKey("removeList"),
      resolvingListText: tKey("resolvingList"),
      listErrorText: tKey("listError"),
      noListsText: tKey("noLists"),
      onlyAssignedToMeText: tKey("onlyAssignedToMe"),
    };
  }, [t]);
};
